import Email from './email'
import * as Common from './common'
import Empty from './empty'
import NotEmpty from './notEmpty'
import Numeric from './numeric'
import Phone from './phone'
import MaxLength from './maxLength'
import MinLength from './minLength'
import Checked from './checked'
import Selected from './selected'
import Url from './url'
import Alphanumeric from './alphanumeric'
import * as helpers from './helper'
import NewMaxLength from './newMaxLength'
import NewMinLength from './newMinLength'
import NewNotEmpty from './newNotEmpty'
import MaxValue from './maxValue'
import MinValue from './minValue'
const validationFunc = {
  Email,
  Common,
  Empty,
  NotEmpty,
  Numeric,
  Phone,
  MaxLength,
  MinLength,
  Checked,
  Selected,
  Url,
  Alphanumeric,
  NewMaxLength,
  NewMinLength,
  NewNotEmpty,
  MaxValue,
  MinValue
}

export default (validation, value, label) => {
  let message = {}
  const valid = validation.every(element => {
    const [fnName, args] = element.split(`:`)
    const fn = validationFunc[fnName]
    const isValid = args ? fn(value, args) : fn(value)
    if (!isValid) {
      message = args
        ? helpers.message(fnName, label, { len: args })
        : helpers.message(fnName, label)
    }
    return isValid === true
  })
  return { valid, message }
}
